import { Theme, SxProps } from '@mui/material';
import { urlProtocolValidatorRegExp } from '../../validators';

export const wait = async (time = 0): Promise<() => void> => new Promise<() => void>((res) => {
  const id = setTimeout(() => {
    res(() => {
      clearTimeout(id);
    });
  }, time);
});

export const handleStopPropagation = (e: MouseEvent) => e.stopPropagation();

export const mergeSX = (baseSX: SxProps<Theme> = {}, overrideSX: SxProps<Theme> = {}) => ({
  ...baseSX,
  ...overrideSX,
});

interface IBuildFilterOptionsAsObjectParams {
  byKey: string;
}
interface IBuildFilterOptionsAsObjectReturn {
  [key: string]: object;
}
export const buildFilterOptionsAsObject = (
  options: object[],
  params?: IBuildFilterOptionsAsObjectParams,
): IBuildFilterOptionsAsObjectReturn => {
  const { byKey = 'value' } = params ?? {};
  return options.reduce<IBuildFilterOptionsAsObjectReturn>((acc, option) => ({
    ...acc,
    [option[byKey as keyof object]]: option,
  }), {});
};

export const removeProtocolFromUrl = (url: string)
  : string => url.replace(urlProtocolValidatorRegExp, '');

export const addHttpsProtocolToUrl = (url: string): string => `https://${url}`;

export const getFloatWithPrecision = (
  float: number,
  precision = 2,
): number => parseFloat((float).toFixed(precision));
